import React, { createContext, useState, useContext, useCallback } from "react";
import { persistVendorServiceType } from "../utils/vendorServiceAccess";

const DataContext = createContext();

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [role, setRole] = useState("");
  const [vendorProfile, setVendorProfileState] = useState(null);
  const [profileUnderReview, setProfileUnderReview] = useState(false);

  const updateModules = (newData) => {
    setModules(newData);
  };

  const setVendorProfile = useCallback((vendor) => {
    setVendorProfileState(vendor);
    persistVendorServiceType(vendor?.service_type);
  }, []);

  return (
    <DataContext.Provider
      value={{
        modules,
        updateModules,
        role,
        setRole,
        vendorProfile,
        setVendorProfile,
        profileUnderReview,
        setProfileUnderReview,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
